import { ProviderOutcome } from "store/payments/operations/slice";

export const hasValue = (value: unknown): boolean =>
  value !== null && value !== undefined && value !== "";

const sentence = (value: string): string =>
  `${value.trim().replace(/[.\s]+$/, "")}.`;

export const buildProviderExplanation = (
  outcome: ProviderOutcome,
  isInternalOrManual = false,
): string => {
  const operationType = hasValue(outcome.operationType)
    ? `${String(outcome.operationType).charAt(0).toUpperCase()}${String(
        outcome.operationType,
      ).slice(1)}`
    : "";
  const status = outcome.terminalStatusCode || outcome.statusCode || "";
  const hasProviderDetails = [
    outcome.providerStatus,
    outcome.providerCode,
    outcome.externalRef,
  ].some(hasValue);
  const isProviderOperation = !isInternalOrManual || hasProviderDetails;
  const parts: string[] = [];

  if (operationType && status) {
    parts.push(
      sentence(
        `${operationType} was ${status}${
          isProviderOperation ? " by provider" : ""
        }`,
      ),
    );
  }

  if (hasValue(outcome.providerStatus)) {
    parts.push(sentence(`Provider status: ${outcome.providerStatus}`));
  }
  if (hasValue(outcome.providerCode)) {
    parts.push(sentence(`Provider code: ${outcome.providerCode}`));
  }
  if (hasValue(outcome.providerMessage)) {
    parts.push(sentence(`Message: ${outcome.providerMessage}`));
  }
  if (hasValue(outcome.externalRef)) {
    parts.push(sentence(`External ref: ${outcome.externalRef}`));
  }

  return parts.join(" ");
};
